<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information">
          <h3>{{ pageData.MenuName }}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>申報年度</td>
                  <td colspan="3">
                    <select v-model="form.syear">
                      <option
                        v-for="(data, index) in dropDownList.syears"
                        :key="index"
                        :value="data"
                      >
                        {{ data }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>服務機關</td>
                  <td colspan="3">
                    <select
                      v-model="form.jobGovCode1"
                      style="min-width: 200px"
                      @change="JobGovCode1Change()"
                      :disabled="
                        loginInfo &&
                        (loginInfo.roleSeq != 1 && loginInfo.roleSeq != 35) &&
                        1 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode1s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode2"
                      style="min-width: 200px"
                      @change="JobGovCode2Change()"
                      :disabled="
                        loginInfo &&
                        (loginInfo.roleSeq != 1 && loginInfo.roleSeq != 35)  &&
                        2 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode2s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode3"
                      style="min-width: 200px"
                      @change="JobGovCode3Change()"
                      :disabled="
                        loginInfo &&
                        (loginInfo.roleSeq != 1 && loginInfo.roleSeq != 35)  &&
                        3 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode3s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode4"
                      style="min-width: 200px"
                      :disabled="
                        loginInfo &&
                        (loginInfo.roleSeq != 1 && loginInfo.roleSeq != 35)  &&
                        4 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode4s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <div>
                      <input
                        type="checkbox"
                        v-model="form.jobGovCheck"
                        true-value="1"
                        false-value="0"
                      />
                      包含所屬機關
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>受理申報機關：</td>
                  <td>
                    <select
                      v-model="form.govCode1"
                      style="min-width: 200px"
                      @change="GovCode1Change()"
                      :disabled="
                        loginInfo &&
                        (loginInfo.roleSeq != 1 && loginInfo.roleSeq != 35)  &&
                        1 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode1s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.govCode2"
                      style="min-width: 200px"
                      @change="GovCode2Change()"
                      :disabled="
                        loginInfo &&
                        (loginInfo.roleSeq != 1 && loginInfo.roleSeq != 35)  &&
                        2 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode2s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.govCode3"
                      style="min-width: 200px"
                      @change="GovCode3Change()"
                      :disabled="
                        loginInfo &&
                        (loginInfo.roleSeq != 1 && loginInfo.roleSeq != 35)  &&
                        3 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode3s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.govCode4"
                      style="min-width: 200px"
                      :disabled="
                        loginInfo &&
                        (loginInfo.roleSeq != 1 && loginInfo.roleSeq != 35)  &&
                        4 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode4s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <div>
                      <input
                        type="checkbox"
                        v-model="form.govCheck"
                        true-value="1"
                        false-value="0"
                      />
                      包含所屬機關
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>身分證統一編號</td>
                  <td colspan="3">
                    <input type="text" v-model="form.idn" />
                  </td>
                </tr>
                <tr>
                  <td>姓名</td>
                  <td colspan="3">
                    <input type="text" v-model="form.name" />
                  </td>
                </tr>
                <tr>
                  <td>職稱</td>
                  <td colspan="3">
                    <input type="text" v-model="form.title" />
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="f_center">
                    <label for="checkbox"
                      ><span>
                        <input
                          type="submit"
                          class="btn"
                          value="查詢"
                          @click="
                            () => {
                              this.form.currentpage = 1;
                              this.form.pagesize = 10;
                              this.doQuery();
                            }
                          "
                        />
                        <input
                          type="submit"
                          class="btn"
                          value="批次查詢"
                          @click="BtnImport()"
                        />
                        <input
                          type="submit"
                          class="btn"
                          value="重填"
                          @click="btnClear()"
                        />
                      </span>
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="f_center"></div>
        </div>
        <!-- 查詢結果開始-->
        <div class="information">
          <table width="100%">
            <tbody>
              <tr>
                <td></td>
                <td align="right" v-if="grid.paginaiton">
                  <input
                    type="button"
                    value="<<"
                    class="btn"
                    style="height: 28px"
                    @click="form.currentpage = grid.paginaiton.pageNo - 1"
                    v-show="grid.paginaiton.pageNo > 1"
                  />
                  <span
                    v-for="(data, index) in grid.paginaiton.pages"
                    :key="index"
                    style="cursor: pointer"
                    :style="
                      grid.paginaiton.pageNo == data
                        ? 'color:red'
                        : 'color:black'
                    "
                    @click="form.currentpage = parseInt(data)"
                  >
                    {{
                      grid.paginaiton.pageNo == data ? "[" + data + "]" : data
                    }}
                  </span>
                  <input
                    type="button"
                    class="btn"
                    value=">>"
                    style="height: 28px"
                    v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                    @click="form.currentpage = grid.paginaiton.pageNo + 1"
                  />
                  ［每頁<input
                    type="text"
                    v-model.number.lazy="form.pagesize"
                    size="2"
                    maxlength="4"
                  />

                  <input type="button" class="btn" value="筆" />，第<input
                    type="text"
                    v-model.number.lazy="form.currentpage"
                    size="2"
                    maxlength="4"
                  />
                  <input type="button" class="btn" value="頁" />，共
                  {{ grid.paginaiton.totalPage }} 頁
                  {{ grid.paginaiton.totalCount }} 筆］
                </td>
              </tr>
            </tbody>
          </table>
          <div class="active">
            <div class="table_scroll2">
              <table width="1060" class="itable">
                <thead>
                  <tr>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('SYEAR', Sort);
                          }
                        "
                        >年度</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('GOV_CODE_NAME', Sort);
                          }
                        "
                        >受理申報機關</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('JOB_GOV_CODE_NAME', Sort);
                          }
                        "
                        >任職機關</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('TITLE', Sort);
                          }
                        "
                        >職稱</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('NAME', Sort);
                          }
                        "
                        >姓名</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('IDN', Sort);
                          }
                        "
                        >身分證統一編號</u
                      >
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in grid.gridDatas" :key="index">
                    <td>{{ data.syear }}</td>
                    <td>{{ data.goV_CODE_NAME }}</td>
                    <td>{{ data.joB_GOV_CODE_NAME }}</td>
                    <td>{{ data.title }}</td>
                    <td>{{ data.name }}</td>
                    <td>{{ data.idn }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 查詢結果結束-->
        </div>
      </div>
      <!-- 頁籤結束 -->
    </div>
    <PdisFooter />
    <ImportModal
      v-model="ImportModal.show"
      :title="ImportModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>上傳檔案</td>
                <td>
                  <input
                    type="file"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    @change="ImportModalOnFileChange"
                  />
                  <input
                    type="submit"
                    class="btn"
                    value="匯入"
                    @click="ImportModalBtnImport()"
                  />
                </td>
              </tr>
              <tr>
                <td>說明</td>
                <td>
                  <p>
                    請下載此範本<a
                      href="/PdpsCli/download/F106_sample.xls"
                      target="_blank"
                      >sample.xls</a
                    >
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </ImportModal>

    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.show = false">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import { getMenuIndex, getMenu, logOut } from "@/config/util.js";
import {
  SearchGovCode,
  F106_SearchGrid,
  F106_ReSearchGrid,
  F106_Import,
} from "@/service/api.js";
export default {
  name: "F106",
  data: function () {
    return {
      pageData: {
        MenuIndex: 4,
        MenuName: "",
        PrgName: "F106",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      SessionGovCode: sessionStorage.getItem("Session_GovCode"),
      Order: "",
      Sort: "",
      form: {
        idn: "",
        name: "",
        title: "",
        syear: "110",
        govCode1: "",
        govCode2: "",
        govCode3: "",
        govCode4: "",
        govCheck: "0",
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        ImportType: "XLSX",
        pagesize: 10,
        currentpage: 1,
      },
      dropDownList: {
        govCode1s: [],
        govCode2s: [],
        govCode3s: [],
        govCode4s: [],
        jobGovCode1s: [],
        jobGovCode2s: [],
        jobGovCode3s: [],
        jobGovCode4s: [],
        syears: [],
      },
      grid: [],
      ImportModal: {
        show: false,
        title: "F106 名單匯入查詢-匯入",
        form: {
          updloaD_FILE: "",
        },
      },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    ImportModal: VueModal,
    Alert: VueModal,
  },
  methods: {
    getSyearDropDownList: function () {
      let syears = [""];
      const startYear = 99; //民國99年
      for (let i = startYear; i <= new Date().getFullYear() - 1911; i++) {
        syears.push(i.toString().length === 2 ? "0" + i : i.toString());
      }
      return syears;
    },
    //取得受理申報機關第一層類別
    getSearchGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode1s = rData.returnObject;
      });
    },
    //取得受理申報機關第二層類別
    getSearchGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode2s = rData.returnObject;
      });
    },
    //取得受理申報機關第三層類別
    getSearchGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode3s = rData.returnObject;
      });
    },
    //取得受理申報機關第四層類別
    getSearchGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode4s = rData.returnObject;
      });
    },
    //取得受理申報機關第一層類別
    getSearchJobGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //取得受理申報機關第二層類別
    getSearchJobGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode2s = rData.returnObject;
      });
    },
    //取得受理申報機關第三層類別
    getSearchJobGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode3s = rData.returnObject;
      });
    },
    //取得受理申報機關第四層類別
    getSearchJobGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode4s = rData.returnObject;
      });
    },
    //第一頁查詢
    doQuery: function () {
      const self = this;
       //清空
      self.Order = "";
      self.Sort = "";
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        IDN: self.form.idn,
        NAME: self.form.name,
        TITLE: self.form.title,
        GOV_CODE: self.form.govCode4
          ? self.form.govCode4
          : self.form.govCode3
          ? self.form.govCode3
          : self.form.govCode2
          ? self.form.govCode2
          : self.form.govCode1
          ? self.form.govCode1
          : "",
        GOVCHECK: parseInt(self.form.govCheck),
        JOB_GOV_CODE: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        JOBGOVCHECK: parseInt(self.form.jobGovCheck),
        SYEAR: self.form.syear,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        //ImportType: self.form.ImportType,
      };
      F106_SearchGrid(postData).then((rData) => {
        if(rData.result){
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    reQuery: function (NM, SC) {
      const self = this;
      if (NM == "" && SC == "") {
        if (self.Order == "" && self.Sort == "") {
          //所謂預設值
          self.Order = "IDN";
          self.Sort = "ASC";
        } else {
          //換頁 self.Order && self.Sort 維持原樣
        }
      } else if (NM == self.Order) {
        //而後的點擊
        if (SC == "ASC") {
          self.Sort = "DESC";
        } else {
          self.Sort = "ASC";
        }
      } else {
        //第一次的點擊
        self.Order = NM;
        self.Sort = "ASC";
      }
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        IDN: self.form.idn,
        NAME: self.form.name,
        TITLE: self.form.title,
        GOV_CODE: self.form.govCode4
          ? self.form.govCode4
          : self.form.govCode3
          ? self.form.govCode3
          : self.form.govCode2
          ? self.form.govCode2
          : self.form.govCode1
          ? self.form.govCode1
          : "",
        GOVCHECK: parseInt(self.form.govCheck),
        JOB_GOV_CODE: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        JOBGOVCHECK: parseInt(self.form.jobGovCheck),
        SYEAR: self.form.syear,
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        SORT: self.Sort,
        ORDER: self.Order,
        //ImportType: self.form.ImportType,
      };
      F106_ReSearchGrid(postData).then((rData) => {
        if(rData.result){
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    //分頁防呆檢查
    checkPage: function (currentpage, pagesize) {
      const self = this;
      let pageErrorMsg = [];
      if (currentpage) {
        if (isNaN(parseInt(currentpage))) {
          pageErrorMsg.push("頁數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫頁數");
      }
      if (pagesize) {
        if (isNaN(parseInt(pagesize))) {
          pageErrorMsg.push("筆數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫每頁筆數");
      }
      if (pageErrorMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = pageErrorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
    //第一頁重填
    btnClear: function () {
      const self = this;
      self.form = {
        idn: "",
        name: "",
        syear: "110",
        title: "",
        govCode1: "",
        govCode2: "",
        govCode3: "",
        govCode4: "",
        govCheck: "0",
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        ImportType: "XLSX",
        pagesize: 10,
        currentpage: 1,
      };
      self.JobGovCodeInit(self.form);
      self.getSearchJobGovCode1();
      self.GovCodeInit(self.form);
      self.getSearchGovCode1();
    },
    GovCodeInit: function (form) {
      const self = this;
      if (self.SessionGovCode != null) {
        form.govCode1 = self.SessionGovCode;
        form.govCode2 = "";
        form.govCode3 = "";
        form.govCode4 = "";
      } else {
        if (self.loginInfo) {
          let govCodeArray = self.loginInfo.govCodeStr.split(",");
          form.govCode1 = govCodeArray[0];
          form.govCode2 = govCodeArray[1];
          form.govCode3 = govCodeArray[2];
          form.govCode4 = govCodeArray[3];
        }
      }
    },
    GovCode1Change: function () {
      const self = this;
      self.form.govCode2 = "";
      self.form.govCode3 = "";
      self.form.govCode4 = "";
      self.dropDownList.govCode2s = [];
      self.dropDownList.govCode3s = [];
      self.dropDownList.govCode4s = [];
    },
    GovCode2Change: function () {
      const self = this;
      self.form.govCode3 = "";
      self.form.govCode4 = "";
      self.dropDownList.govCode3s = [];
      self.dropDownList.govCode4s = [];
    },
    GovCode3Change: function () {
      const self = this;
      self.form.govCode4 = "";
      self.dropDownList.govCode4s = [];
    },
    JobGovCodeInit: function (form) {
      const self = this;
      if (self.SessionGovCode != null) {
        form.jobGovCode1 = self.SessionGovCode;
        form.jobGovCode2 = "";
        form.jobGovCode3 = "";
        form.jobGovCode4 = "";
      } else {
        if (self.loginInfo) {
          let govCodeArray = self.loginInfo.govCodeStr.split(",");
          form.jobGovCode1 = govCodeArray[0];
          form.jobGovCode2 = govCodeArray[1];
          form.jobGovCode3 = govCodeArray[2];
          form.jobGovCode4 = govCodeArray[3];
        }
      }
    },
    JobGovCode1Change: function () {
      const self = this;
      self.form.jobGovCode2 = "";
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode2s = [];
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode2Change: function () {
      const self = this;
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode3Change: function () {
      const self = this;
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode4s = [];
    },
    //第一頁匯入
    BtnImport: function () {
      const self = this;
      self.ImportModal.show = true;
    },
    //匯入頁 按紐匯入
    ImportModalBtnImport: function () {
      const self = this;
      if (self.ImportModal.form.updloaD_FILE) {
        let formData = new FormData();
        formData.append("UPDLOAD_FILE", self.ImportModal.form.updloaD_FILE);
        formData.append("SYEAR", self.form.syear);
        formData.append("LogInfo.Id", self.loginInfo.id);
        formData.append("LogInfo.PrgCode", self.pageData.PrgName);
        formData.append("LogInfo.ActCd", "匯入");
        formData.append("LogInfo.Token",self.loginInfo.token);
        formData.append("LogInfo.ServiceUnit", self.pageData.ServiceUnit);

        F106_Import(formData).then((rData) => {
          if (rData[0] != "ERROR") {
            let link = document.createElement("a");
            link.download = "產出名單";
            link.href = "data:application/pdf;base64," + rData[0];
            link.click();

            self.Alert.show = true;
            self.Alert.title = "正確";
            self.Alert.txt = ["產出名單成功!"];
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = [rData[1]]; //=rData.messages;//
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
        });
      } else {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = ["請先選取匯入檔案"];
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
      }
    },
    //匯入頁
    ImportModalOnFileChange: function (event) {
      const self = this;
      self.ImportModal.form.updloaD_FILE = event.target.files[0];
    },
  },
  watch: {
    "form.jobGovCode1": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode2(newValue);
    },
    "form.jobGovCode2": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode3(newValue);
    },
    "form.jobGovCode3": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode4(newValue);
    },
    "form.govCode1": function (newValue, oldValue) {
      if (newValue != "") this.getSearchGovCode2(newValue);
    },
    "form.govCode2": function (newValue, oldValue) {
      if (newValue != "") this.getSearchGovCode3(newValue);
    },
    "form.govCode3": function (newValue, oldValue) {
      if (newValue != "") this.getSearchGovCode4(newValue);
    },
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if (Menu) {
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    self.dropDownList.syears = self.getSyearDropDownList();
    self.GovCodeInit(self.form);
    self.JobGovCodeInit(self.form);
    self.getSearchGovCode1();
    self.getSearchJobGovCode1();
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
